import { z } from 'zod';

export interface IUserForm {
	id?: string;
	email: string;
	name: string;
	role: string;
}

export const UserFromSchema: z.ZodType<IUserForm> = z.object({
	id: z.string().optional(),
	email: z
		.string()
		.min(1, 'Email is required')
		.email('Invalid email address'),
	name: z.string().min(1, 'Name is required'),
	role: z.string().min(1, 'Role is required'),
});

export interface IUser extends IUserForm {
	id: string;
	isEmailVerified: boolean;
	isInvited: boolean;
	account: string;
	permissions?: string[];
}

export interface IUsers {
	limit: number;
	page: number;
	results: Array<IUser>;
	totalPages: number;
	totalResults: number;
}
